import { render, staticRenderFns } from "./previewQuestion.vue?vue&type=template&id=d43c086c&scoped=true"
import script from "./previewQuestion.vue?vue&type=script&lang=js"
export * from "./previewQuestion.vue?vue&type=script&lang=js"
import style0 from "./previewQuestion.vue?vue&type=style&index=0&id=d43c086c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d43c086c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d43c086c')) {
      api.createRecord('d43c086c', component.options)
    } else {
      api.reload('d43c086c', component.options)
    }
    module.hot.accept("./previewQuestion.vue?vue&type=template&id=d43c086c&scoped=true", function () {
      api.rerender('d43c086c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/componentsTeacher/curriculum-manage/previewQuestion.vue"
export default component.exports